// Shared, cached public site settings. Every consumer (analytics bootstrap,
// footer social icons, promo banner…) awaits the SAME single request instead
// of each firing its own /api/site call — fewer round-trips, faster paint.
import { api } from '@/lib/api';

let sitePromise = null;

export function getSite() {
  if (!sitePromise) {
    sitePromise = api
      .get('/site')
      .then(r => r.data?.site || null)
      .catch(() => {
        sitePromise = null; // allow a retry on next call
        return null;
      });
  }
  return sitePromise;
}
